import 'public/js/flexslider/jquery-ui/jquery-ui.js'
import 'public/js/flexslider/jquery-ui/jquery.ui.touch-punch.js'
import 'public/js/flexslider/jquery.flexslider.js'
